import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import moment from 'moment';
import { Modal, Spin } from 'antd';
import { ArrowLeftIcon, ArrowRightIcon, CloseIcon } from '../../icons';
import AirList from '../AirList';
import isFunction from 'lodash/isFunction';

import './AirNoticeCarousel.css';

@inject('translationsStore', 'noticesStore')
@observer
export default class AirNoticeCarousel extends Component {
  constructor(props) {
    super(props);

    this.pageSize = 7;
    this.state = {
      currentPage: 1,
    };

  }

  switchToItem = ({ index: selectedIndex, page}) => {
    this.setState({ currentPage: page !== undefined ? page : this.state.currentPage },() => {

      const { onChange, selectedIndex: prevSelectedIndex } = this.props;
      onChange(selectedIndex, prevSelectedIndex);

    });
  };

  onCarouselLeftButtonClick = () => {
    let { selectedIndex } = this.props;
    const { currentPage } = this.state;
    let page = undefined;
    // selectedIndex = selectedIndex === 0 ? items.length - 1 : --selectedIndex;
    selectedIndex = --selectedIndex;
    if (selectedIndex < 0) {
      selectedIndex = this.pageSize - 1;
      page = currentPage - 1;
    }
    if (page !== undefined && page !== currentPage) {
      this.props.onPageChange(page).then(() => {
        this.switchToItem({ index: selectedIndex, page });
      });
    } else {
      this.switchToItem({ index: selectedIndex });
    }
  };

  onCarouselRightButtonClick = () => {
    let { selectedIndex } = this.props;
    const { currentPage } = this.state;
    let page = undefined;
    // selectedIndex = selectedIndex === items.length - 1 ? 0 : ++selectedIndex;
    selectedIndex = ++selectedIndex;
    const virtualIndex = (currentPage - 1) * this.pageSize + selectedIndex;
    if (virtualIndex >= this.props.total) {
      selectedIndex = 0;
      page = 1;
    } else if (selectedIndex >= this.pageSize ) {
      selectedIndex = 0;
      page = currentPage + 1;
    }
    if (page !== undefined && page !== currentPage) {
      this.props.onPageChange(page).then(() => {
        this.switchToItem({ index: selectedIndex, page });
      });
    } else {
      this.switchToItem({ index: selectedIndex });
    }
  };

  onCarouselButtonDoubleClick = e => {
    e.stopPropagation();
    return false;
  };

  renderBrick = (item, index, selected) => {
    const { currentPage } = this.state;
    const virtualIndex = (currentPage - 1) * this.pageSize + index + 1;
    if (isFunction(this.props.renderSideItem)) {
      this.props.renderSideItem(item, index, selected);
    } else {
      return (
        <div onClick={() => this.switchToItem({ index })} className={`brick ${selected ? 'selected' : ''}`}>
          <div className="bg" />
          <div className="brickInner">
            <div>{virtualIndex}</div>
            <div>{moment(item.timestamp).format('DD/MM/YYYY')}</div>
            <div>{moment(item.timestamp).format('HH:mm')}</div>
          </div>
        </div>
      );
    }
  };

  onPageChange = (page) => {
    if (isFunction(this.props.onPageChange)) {
      this.props.onPageChange(page).then(() => {

        const userIndex = 0;
        this.switchToItem({ index: userIndex, page });
      });
    }
  };

  render() {
    const { selectedIndex, onCancel, noticesStore } = this.props;
    let { items } = this.props;
    items = items.map((item, index) => ({...item, key: index}));
    const { currentPage } = this.state;
    const virtualIndex = (currentPage - 1) * this.pageSize + selectedIndex + 1;

    const [carouselButtonWidth, carouselButtonHeight] = [60, 60];
    const defaultWidth = 800;
    const defaultHeight = 500;

    const clientWidth = this.props.width || defaultWidth;
    const clientHeight = this.props.height || defaultHeight;
    const carouselLeftButtonStyle = {
      left: -carouselButtonWidth - 10,
      top: (clientHeight/2)-(carouselButtonHeight/2),
      display: (this.props.total <= 1 || virtualIndex < 1) ? 'none' : undefined
    };
    const carouselRightButtonStyle = {
      right: -carouselButtonWidth - 10,
      top: (clientHeight/2)-(carouselButtonHeight/2),
      display: (this.props.total <= 1 || virtualIndex >= this.props.total) ? 'none' : undefined
    };

    return (
      <Modal
        closable={false}
        footer={false}
        className={`AirNoticeCarousel ${this.props.className || ''}`}
        centered={true}
        onCancel={() => onCancel(selectedIndex)}
        visible={this.props.visible}
        width={clientWidth}
        bodyStyle={{height: clientHeight}}
      >
        <div style={{width:'100%', height:'100%', display:'flex', flexDirection:'column'}}>
          <div className="CarouselTitleBar" style={this.props.titleBarStyle}>
            {this.props.title}
            <div style={{width: 16, height: 16}} onClick={() => onCancel(selectedIndex)}><CloseIcon width="16px" height="16px" /></div>
          </div>
          <div className="CarouselBody">

            <div className="CarouselItemStack">

              <Spin spinning={noticesStore.virtualLoading} className="tempo">
                <AirList
                  className="CarouselItemStackInner"
                  paginationPosition="bottom"
                  pageSize={this.pageSize}
                  dataSource={items || []}
                  renderItem={(item, index) => {return this.renderBrick(item, ((this.props.total !== undefined) ? item.key : index), ((this.props.total !== undefined) ? item.key : index)===selectedIndex)}}

                  currentPage={this.state.currentPage}
                  onPageChange={this.onPageChange}
                  total={this.props.total}
                />
              </Spin>

            </div>
            <div className="CarouselItemDetail">
              <Spin spinning={noticesStore.virtualLoading} className="tempo">
                {this.props.renderDetail(items[selectedIndex])}
              </Spin>
            </div>
          </div>
        </div>
        <div className="CarouselButton CarouselLeftButton" style={carouselLeftButtonStyle} onClick={this.onCarouselLeftButtonClick} onDoubleClick={this.onCarouselButtonDoubleClick}>
          <ArrowLeftIcon width="24px" height="24px" />
        </div>
        <div className="CarouselButton CarouselRightButton" style={carouselRightButtonStyle} onClick={this.onCarouselRightButtonClick} onDoubleClick={this.onCarouselButtonDoubleClick}>
          <ArrowRightIcon width="24px" height="24px" />
        </div>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/AirNoticeCarousel/AirNoticeCarousel.js